import Modal from "./modal"

const menu = document.querySelector("#site-navigation")
const openButton = document.querySelector("#js-open-menu")
const closeButton = document.querySelector("#js-close-menu")

const Navigation = {
	init: () => {
		if (!menu) return

		Navigation.bindEvents()
	},

	bindEvents: () => {
		document.addEventListener("click", function (e) {
			if (openButton.contains(e.target)) {
				Modal.open(menu)
				document.querySelector("body").classList.add("menu-open")
			} else if (closeButton.contains(e.target)) {
				Modal.close(menu)
				document.querySelector("body").classList.remove("menu-open")

			}
		})
	},
}

export default Navigation
